//
export interface Color {
  r: number;
  g: number;
  b: number;
  a?: number; // Optional alpha channel
  name?: string; // Optional name, generally reserved for special colors e.g. "blue".
}

function color(
  r: number,
  g: number,
  b: number,
  a?: number,
  name?: string
): Color {
  return { r, g, b, a, name };
}

export const Color = {
  // Create a new color object
  new: color,

  // Convert to a string representation
  str: (c: Color): string => {
    if (c.name) return c.name; // Use the name if available
    if (c.a) return `rgba(${c.r}, ${c.g}, ${c.b}, ${c.a})`;
    return `rgb(${c.r}, ${c.g}, ${c.b})`;
  },

  // Export some common colors
  black: color(0, 0, 0, 1, "black"),
  white: color(255, 255, 255, 1, "white"),
  red: color(255, 0, 0, 1, "red"),
  green: color(0, 255, 0, 1, "green"),
  blue: color(0, 0, 255, 1, "blue"),
  yellow: color(255, 255, 0, 1, "yellow"),
  orange: color(255, 165, 0, 1, "orange"),
  grey: color(128, 128, 128, 1, "grey"),
  darkgrey: color(169, 169, 169, 1, "darkgrey"),
  maroon: color(128, 0, 0, 1, "maroon"),
  cyan: color(0, 255, 255, 1, "cyan"),

  // Grid line greys — themed by background brightness and intensity.
  // The "subtle" tones are the default; "bold" tones are used when the
  // user opts into high grid intensity from the IDE preferences.
  gridLine: {
    darkSubtle: color(34, 34, 34), // Subtle grid on black bg
    darkBold: color(68, 68, 68), // Bold grid on black bg
    lightSubtle: color(221, 221, 221), // Subtle grid on white bg
    lightBold: color(180, 180, 180), // Bold grid on white bg
  },
} as const;
